
import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'textarea-field',
  imports: [ReactiveFormsModule],
  templateUrl: './textarea-field.component.html',
  styleUrl: './textarea-field.component.scss'
})
export class TextAreaFieldComponent {

  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() readonly!:boolean
  @Input() height?: number = 100;

  @Input() textareaFormControl!: FormControl

  @ViewChild('textAreaField') textAreaField!: ElementRef;

  constructor(private renderer: Renderer2) { }


}
